module.exports = __webpack_public_path__ + "img/special-4.d14fbc61.jpg";